import { render, staticRenderFns } from "./PlatformSingleSelect.vue?vue&type=template&id=2e2f4695&scoped=true"
import script from "./PlatformSingleSelect.vue?vue&type=script&lang=js"
export * from "./PlatformSingleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2f4695",
  null
  
)

export default component.exports